import { MedicalAidPickerComponent } from '../shared/components/medical-aid-picker/medical-aid-picker.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { RouterModule } from '@angular/router';
import { AngularCanvasModule } from '@e-signature/ng-signature-pad';
import { SharedModule } from '../shared/shared.module';
import { AcceptInviteComponent } from './components/accept-invite/accept-invite.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { PatientInviteWizardComponent } from './components/patient-invite-wizard/patient-invite-wizard.component';
import { DocumentFillDialogComponent } from './components/patient-invite-wizard/document-fill-dialog/document-fill-dialog.component';
import { PatientFormComponent } from './components/patient-form/patient-form.component';
import { PatientSatisfactionSurveyComponent } from './components/patient-satisfaction-survey/patient-satisfaction-survey.component';
import { RegisterComponent } from './components/register/register.component';
import { RejectInviteComponent } from './components/reject-invite/reject-invite.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { RemoatSignInComponent } from './components/remoat-sign-in/remoat-sign-in.component';
import { RelaymdSignInComponent } from './components/relaymd-sign-in/relaymd-sign-in.component';
import { VerifyPrescriptionComponent } from './components/verify-prescription/verify-prescription.component';
import { VerifyReportComponent } from './components/verify-report/verify-report.component';


const MAT_MODULES = [
  MatCardModule,
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatIconModule,
  MatSelectModule,
  MatProgressBarModule,
  MatDatepickerModule,
  MatMomentDateModule,
  MatStepperModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatCheckboxModule
]

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    AcceptInviteComponent,
    RejectInviteComponent,
    PatientInviteWizardComponent,
    /*
     * TIER A — `practice-documents.md` §5. The full-screen AcroForm viewer the invite wizard's
     * document step opens for a document whose `fillMode` is `embedded`. Declared here rather
     * than in `SharedModule` because it has exactly one host; the viewer element it renders comes
     * from `NgxExtendedPdfViewerModule`, which `SharedModule` (imported below) already exports.
     */
    DocumentFillDialogComponent,
    VerifyEmailComponent,
    RemoatSignInComponent,
    RelaymdSignInComponent,
    VerifyPrescriptionComponent,
    VerifyReportComponent,
    PatientSatisfactionSurveyComponent,
    // `/patient-form/:token`. It renders no fields of its own — every control comes from
    // `DynamicFormRendererComponent`, which `SharedModule` (imported below) exports.
    PatientFormComponent,
    /*
     * `PatientDocumentComponent` USED TO BE DECLARED HERE and is gone - practice-documents.md 19.
     * The standalone `/patient-document/:token` page is retired; a document return is a step in
     * `PatientInviteWizardComponent` above, and a manual send mints a document-only invite (21.2).
     */
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AngularCanvasModule,
    MedicalAidPickerComponent,
    ...MAT_MODULES
  ],
  exports: [
    LoginComponent,
    AcceptInviteComponent,
  ],
  providers: [
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  ]
})
export class UserModule { }
